export const passosReframing = [
  {
    numero: 1,
    titulo: "Identifique a Situação",
    descricao: "Escolha uma situação específica que gera emoção negativa ou limitação",
    icone: "ri-focus-3-line",
    cor: "from-rose-500 to-pink-500"
  },
  {
    numero: 2,
    titulo: "Encontre a Intenção Positiva",
    descricao: "Todo comportamento tem uma intenção positiva. Descubra qual é",
    icone: "ri-heart-3-line",
    cor: "from-purple-500 to-violet-500"
  },
  {
    numero: 3,
    titulo: "Mude a Perspectiva de Contexto",
    descricao: "Em que contexto esse comportamento seria útil ou apropriado?",
    icone: "ri-compass-3-line",
    cor: "from-blue-500 to-cyan-500"
  },
  {
    numero: 4,
    titulo: "Mude a Perspectiva de Conteúdo",
    descricao: "Que outro significado essa situação pode ter?",
    icone: "ri-lightbulb-line",
    cor: "from-amber-500 to-orange-500"
  },
  {
    numero: 5,
    titulo: "Perguntas Poderosas 'E se...'",
    descricao: "Use perguntas para expandir possibilidades e criar novos significados",
    icone: "ri-question-line",
    cor: "from-emerald-500 to-teal-500"
  },
  {
    numero: 6,
    titulo: "Integre o Novo Significado",
    descricao: "Ancorе o novo significado empoderador na sua mente",
    icone: "ri-checkbox-circle-line",
    cor: "from-indigo-500 to-purple-500"
  }
];

export const exemplosReframing = [
  {
    situacao: "Meu chefe me deu um feedback negativo na reunião",
    significadoAtual: "Ele não gosta de mim e acha que sou incompetente",
    intencaoPositiva: "Proteger minha autoestima e evitar sentir vergonha",
    novoSignificado: "Ele está investindo tempo para me ajudar a crescer profissionalmente. Feedback é um presente que me torna melhor.",
    contexto: "Em um contexto de desenvolvimento, feedback direto é sinal de que a pessoa acredita no meu potencial",
    perguntasPoderosas: [
      "E se esse feedback for exatamente o que eu preciso para alcançar o próximo nível?",
      "E se ele estiver me preparando para uma promoção futura?",
      "E se eu agradecer e usar isso como combustível para melhorar?"
    ]
  },
  {
    situacao: "Fui rejeitado em uma entrevista de emprego",
    significadoAtual: "Não sou bom o suficiente e nunca vou conseguir",
    intencaoPositiva: "Evitar a dor da rejeição e proteger minha confiança",
    novoSignificado: "Cada 'não' me aproxima do 'sim' certo. Essa empresa não era o match ideal para mim neste momento.",
    contexto: "No contexto de crescimento, rejeições são redirecionamentos para oportunidades melhores",
    perguntasPoderosas: [
      "E se essa rejeição estiver me protegendo de um ambiente que não seria bom para mim?",
      "E se o emprego perfeito estiver esperando logo à frente?",
      "E se eu usar essa experiência para me preparar ainda melhor?"
    ]
  },
  {
    situacao: "Meu parceiro(a) está sempre ocupado(a) e não tem tempo para mim",
    significadoAtual: "Ele(a) não me ama mais e não me valoriza",
    intencaoPositiva: "Proteger meu coração de possível abandono",
    novoSignificado: "Ele(a) está trabalhando duro para construir nosso futuro juntos. Posso apoiar e criar momentos de qualidade.",
    contexto: "Em um contexto de parceria, trabalho duro pode ser uma forma de amor e cuidado com o futuro",
    perguntasPoderosas: [
      "E se essa fase passar e formos mais fortes depois?",
      "E se eu criar pequenos momentos especiais que não dependam de muito tempo?",
      "E se eu comunicar minhas necessidades de forma amorosa?"
    ]
  },
  {
    situacao: "Cometi um erro importante no trabalho",
    significadoAtual: "Sou um fracasso e vou ser demitido",
    intencaoPositiva: "Evitar a dor da falha e manter minha autoimagem intacta",
    novoSignificado: "Erros são professores poderosos. Agora sei exatamente o que não fazer e posso criar sistemas para evitar isso no futuro.",
    contexto: "No contexto de aprendizado, erros são dados valiosos que nos tornam especialistas",
    perguntasPoderosas: [
      "E se esse erro me ensinar algo que nenhum curso poderia ensinar?",
      "E se eu compartilhar o aprendizado e ajudar toda a equipe?",
      "E se daqui a 5 anos eu agradecer por ter aprendido isso agora?"
    ]
  },
  {
    situacao: "Não consigo parar de procrastinar",
    significadoAtual: "Sou preguiçoso e sem disciplina",
    intencaoPositiva: "Evitar o desconforto de tarefas difíceis e proteger minha energia",
    novoSignificado: "Meu cérebro está me sinalizando que preciso de uma estratégia melhor. Posso dividir tarefas e criar recompensas.",
    contexto: "No contexto de produtividade, procrastinação é um sinal de que o sistema precisa ser ajustado, não que eu seja falho",
    perguntasPoderosas: [
      "E se eu começar apenas 5 minutos e ver o que acontece?",
      "E se eu transformar isso em um jogo divertido?",
      "E se eu celebrar cada pequeno progresso?"
    ]
  }
];

export const dicasReframing = [
  "A pergunta mais poderosa do Reframing: 'Que outro significado isso pode ter?'",
  "Todo comportamento faz sentido no contexto em que foi aprendido",
  "Não existe fracasso, apenas feedback",
  "A intenção positiva nem sempre é óbvia — procure mais fundo",
  "Reframing não é negar a realidade, é expandir as possibilidades",
  "Pergunte: 'Em que situação isso seria uma vantagem?'",
  "O significado que você dá às coisas determina como você se sente",
  "Reframing de contexto: mude ONDE. Reframing de conteúdo: mude O QUÊ",
  "Use 'E se...' para abrir portas mentais que estavam fechadas",
  "Pratique reframing com situações pequenas antes das grandes"
];

export const perguntasPoderosas = [
  "E se isso estiver acontecendo PARA mim, não CONTRA mim?",
  "Que presente ou aprendizado está escondido nessa situação?",
  "Como eu vou agradecer por isso daqui a 5 anos?",
  "Se meu melhor amigo passasse por isso, o que eu diria para ele?",
  "Que qualidade ou força essa situação está desenvolvendo em mim?",
  "Em que contexto isso seria considerado uma vantagem?",
  "O que essa situação está me ensinando sobre mim mesmo?",
  "Como posso usar isso para me tornar mais forte?",
  "Que oportunidade está se abrindo que eu ainda não vi?",
  "Se eu soubesse que tudo vai dar certo, como eu agiria agora?",
  "Qual é a intenção positiva por trás desse comportamento?",
  "Como essa experiência pode me preparar para algo maior?",
  "O que de bom pode surgir disso que eu não esperava?",
  "Se isso fosse um teste, o que estaria sendo testado?",
  "Como posso transformar isso em combustível para meu crescimento?"
];

export const tiposReframing = [
  {
    tipo: "Reframing de Contexto",
    descricao: "Muda o ONDE — Em que situação esse comportamento seria útil?",
    exemplo: "'Sou teimoso' → 'Sou persistente quando acredito em algo importante'"
  },
  {
    tipo: "Reframing de Conteúdo",
    descricao: "Muda o QUE — Que outro significado essa situação pode ter?",
    exemplo: "'Fui rejeitado' → 'Fui redirecionado para algo melhor'"
  }
];